import Waveform from './Waveform';

export default Waveform;



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/components/FullECGPreview/Waveform/index.js